var headerCartInstance;

$(document).ready(function () {
    headerCart($('[data-header-cart]'));
    productAdd($('[data-product-add-to-cart]'));
    //change product variant selection
    setupVariantSelector()
    initFitVids();
    //init slick sliders
    initSlickSliders()
    //Account Actions
    initAccountActions();

    var $insta = $('#instafeed[data-access-token]');
    if ($insta.length) {
        initInstagram();
    }

    addCustomEvents();

    $(".prodThumb a").hover(function () {
            if ($(this).find('.imgWrap').children('.overlay__video').length) {
                $(this).find('.overlay__video video').trigger('play');
            }
        },
        function () {
            if ($(this).find('.imgWrap').children('.overlay__video').length) {
                $(this).find('.overlay__video video').trigger('pause');
            }
        });

})

function initSlickSliders() {
    setSlick($('.slickSlider ul'));
    $('#product-photo-thumbs-mobile').slick({
        centerMode: true,
        centerPadding: '60px',
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
        prevArrow: '<button class="slide-arrow prev-arrow"><img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cG9seWdvbiBwb2ludHM9IjguMjkzIDUuMDAxIDguOTk5IDQuMjkzIDE2LjcwNyAxMS45NzggOS4wMTMgMTkuNzA3IDguMzA0IDE5LjAwMiAxNS4yOTMgMTEuOTgxIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDEyLjUgMTIpIi8+Cjwvc3ZnPgo="></button>',
        nextArrow: '<button class="slide-arrow next-arrow"><img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8cG9seWdvbiBwb2ludHM9IjguMjkzIDUuMDAxIDguOTk5IDQuMjkzIDE2LjcwNyAxMS45NzggOS4wMTMgMTkuNzA3IDguMzA0IDE5LjAwMiAxNS4yOTMgMTEuOTgxIi8+Cjwvc3ZnPgo="></button>'
    });
}

function addCustomEvents() {

    //size guide
    jQuery(document).on('click', ".sizeguide_trigger", () => {
        $(".sizeguidesss").first().click();
    });

    jQuery(document).on('DOMNodeInserted', "#webyze-product-colors-6654990483554", () => {
        $(this).hide();
    })
    //sticky product information
    $(document).on('DOMNodeInserted', '#fsb_container', () => {
        $(".pro-rap").css('top', '202px');
        $("#fsb_close").on('click', () => {
            $(".pro-rap").css('top', '150px');
        })
        window.setTimeout(() => {
            $(".pro-rap").css('top', '150px');
        }, 10000)
    });

    $(document).on('scroll', () => {
        var scrollTop = parseInt($(document).scrollTop());
        if (scrollTop > 600) {
            $("body").addClass('sticky-form');
        } else {
            $("body").removeClass('sticky-form');
        }
    });

    // This button will increment the value
    $('.cart_qtyplus').click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var field = $('input[id=' + fieldName + ']');
        var currentVal = parseInt(field.val());
        // If is not undefined
        let newVal;
        if (!isNaN(currentVal)) {
            // Increment
            newVal = currentVal + 1;
        } else {
            // Otherwise put a 0 there
            newVal = 0;
        }
        field.val(newVal);
        updateCart(newVal, field.attr('var_id'));
        return false;
        
    });

    // This button will decrement the value till 0
    $(".cart_qtyminus").click(function (e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var field = $('input[id=' + fieldName + ']');
        var currentVal = parseInt(field.val());
        // If it isn't undefined or its greater than 0
        let newVal;
        if (!isNaN(currentVal) && currentVal > 0) {
            newVal = currentVal - 1;
            // Decrement one
        } else {
            // Otherwise put a 0 there
            newVal = 0
        }
        field.val(newVal);
        updateCart(newVal, field.attr('var_id'));
        return false;
        
    });
    //update onchange input qty on cart page.
    $('.cart_quantity').on('keyup change', function (e) {
        e.preventDefault();
        var qty = $(this).val();
        var variant = $(this).attr('var_id');
        updateCart(qty, variant)
        return false;
    });

    function updateCart(qty, variant) {
        $.ajax({
            type: 'POST',
            async: false,
            url: '/cart/change.js',
            data: {
                id: variant,
                quantity: qty,
                //properties: new_properties
            },
            dataType: 'json',
            success: function () {
                var path = Theme.localization.locale_code == 'en' ? '/cart' : '/' + Theme.localization.locale_code + '/cart'
                location.href = path;
            }
        });
    }
}

window.slideshows = [];

function setSlick(target) {
    target.each(function () {
        var $t = $(this),
            $n = $t.closest('.slickSlider').find('span.next'),
            $p = $t.closest('.slickSlider').find('span.prev'),
            $full = parseInt($t.attr('data-full'), 10),
            $tab = parseInt($t.attr('data-tab'), 10),
            $mob = parseInt($t.attr('data-mob'), 10),
            slides = $t.find('li').size(),
            $auto = $t.attr('data-auto'),
            swipe = $t.attr('data-swipe') ? $t.attr('data-swipe') : true
        fade = $t.closest('.slickSlider').attr('data-transition') === 'fade';

        if ($auto === "true") {
            $auto = true;
        } else {
            $auto = false;
        }

        var $time = parseInt($t.attr('data-timeout'), 10)
        if (slides > 1) {
            var SlickSlider = $t.slick({
                autoplay: $auto,
                autoplaySpeed: $time,
                slidesToShow: $full,
                swipe: swipe,
                pauseOnHover: true,
                speed: 700,
                infinite: true,
                arrows: false,
                accessibility: false,
                dots: false,
                fade: fade,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1080,
                        settings: {
                            slidesToShow: $full
                        }
                    },
                    {
                        breakpoint: 736,
                        settings: {
                            slidesToShow: $tab
                        }
                    },
                    {
                        breakpoint: 568,
                        settings: {
                            slidesToShow: $mob
                        }
                    }
                ],
                touchDrag: true,
                mouseDrag: false
            });
            $n.click(function () {
                SlickSlider.slick('slickNext')
            });
            $p.click(function () {
                SlickSlider.slick('slickPrev')
            });

            window.slideshows.push(SlickSlider);
        } else {
            $t.addClass('slick-initialized');
        }
    });
}

function initInstagram() {
    var instagramContainer = $('#instafeed[data-access-token]');
    var accessToken = instagramContainer.attr('data-access-token');
    var imageCount = instagramContainer.attr('data-image-count');
    var logo = JSON.parse(instagramContainer.attr('data-instagram-svg'));
    var showText = JSON.parse(instagramContainer.attr('data-instagram-text'));

    if (!instagramContainer.length || accessToken == null || !accessToken.length) return;

    $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + accessToken + '&count=' + imageCount + '&callback=',
        success: function (data) {
            for (var i = 0; i < imageCount; i++) {
                var imageData = data.data[i];

                var time = moment.unix(imageData.created_time).format("MMMM D, YYYY");
                var text = imageData.caption ? '<p class="instaItem-description">' + imageData.caption.text + '</p>' : ''

                var imageInfo = !showText ? '' : '<time>' + time + '</time>' + text + '<a class="instaItem-link" href="' + imageData.link + '" target="_blank">' + logo + '<span>View on Instagram</span></a>';
                var imageObject = '<li class="flexItem"><a href="' + imageData.link + '" target="_blank"><img src="' + imageData.images.standard_resolution.url + '" alt=""><span class="instaItem-overlay">' + logo + '</span></a>' + imageInfo + '</li>';

                instagramContainer.append(imageObject);
            }
        }
    }).complete(function () {
    });
}

function setupVariantSelector() {
    var elements = document.querySelectorAll("[data-product-form]");
    var promises = [];
    elements.forEach(function (element) {
        promises.push(ProductForm(element));
    });

    new Promise(function (myResolve, myReject) {
        Promise.all(promises).then(() => {
            VariantSelectors();
            styleForm()
            myResolve();
        });
    }).then(() => {
        $('.productInfo').animate({opacity: "1"}, 500)
    });

    function VariantSelectors() {
        var $variants = $(document).find('[id^="webyze-product-colors"] > span');
        var select = $("<select>");
        if ($variants.length > 0) {
            $.each($variants, (index, element) => {
                var backgroundImage = $($(element).find("div")[0]).css('background-image');
                var backgroundColor = $($(element).find("div")[0]).css('background-color');
                var option = $('<option value="' + $(element).data('handle') + '" class="color-option">' + $(element).data('name') + '</option>');
                option.data('background-color', backgroundColor);
                option.data('background-image', backgroundImage);
                if ($(element).hasClass('currentSwatch')) {
                    option.attr('selected', 'selected');
                }
                select.append(option)
            });

            select.change((event) => {
                var str = "";
                select.find("option:selected").each(function () {
                    $(document).find('[id^="webyze-product-colors"] > span[data-handle="' + $(this).val() + '"]').click();
                });
            })

            var selectElement = $('.single-option-selector[data-option="option1"]');
            if (selectElement.length > 0) {
                $(selectElement[0]).replaceWith(select);
            }
        }
    }


    function styleForm() {
        $('.shopify-product-form .selector-wrapper select').each(function () {

            var $this = $(this), numberOfOptions = $(this).children('option').length;

            $this.addClass('select-hidden');
            $this.wrap('<div class="select"></div>');
            $this.after('<div class="select-styled"></div>');

            var $styledSelect = $this.next('div.select-styled');
            $styledSelect.html($this.find('option:selected')[0].innerHTML);

            var $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);

            for (var i = 0; i < numberOfOptions; i++) {
                let element = $('<li />', {
                    rel: $this.children('option').eq(i).val()
                });
                if ($this.children('option').eq(i)[0].classList.contains('color-option')) {
                    element.append($("<span>", {
                        class: 'pattern',
                        style: 'background-color: ' + $($this.children('option').eq(i)[0]).data('background-color') + '; background-image: ' + $($this.children('option').eq(i)[0]).data('background-image')
                    }))
                    element.append($("<span>", {
                        class: 'name',
                    }).html($this.children('option').eq(i)[0].innerHTML))
                } else {
                    element.html($this.children('option').eq(i)[0].innerHTML);
                }

                if ($this.children('option').eq(i)[0].classList.contains('sold-out')) {
                    element.addClass('sold-out');
                }

                element.appendTo($list);
                //if ($this.children('option').eq(i).is(':selected')){
                //  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
                //}
            }

            var $listItems = $list.children('li');

            $styledSelect.click(function (e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function () {
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });

            $listItems.click(function (e) {
                e.stopPropagation();
                $styledSelect.html($(this)[0].innerHTML).removeClass('active');
                $this.val($(this).attr('rel')).trigger('change');
                $list.hide();
            });

            $(document).click(function () {
                $styledSelect.removeClass('active');
                $list.hide();
            });

        });
    }

    function ProductForm(element) {
        return new Promise(function (myResolve, myReject) {
            var $element = $(element);

            if (!$element.length) return;

            var variantStyle = $element.attr('data-variant-style');
            var optionsSize = Number($element.attr('data-options-size'));
            var variantsSize = Number($element.attr('data-variants-size'));
            var firstOption = $element.attr('data-first-option');
            var firstVariantTitle = $element.attr('data-first-variant-title');

            var template_index = document.body.classList.contains("template-index");

            var product = $element.find("[data-product-json]").html(),
                product = JSON.parse(product);

            var option_library = (variantStyle === "buttons") ? $element.attr('data-variant-selection-js') : $element.attr('data-option-selection-js');

            if (template_index) {
                option_selectors();
            } else {
                $.getScript(option_library, option_selectors);
            }

            function option_selectors(data) {
                new Shopify.OptionSelectors('ProductSelect-' + product.id, {
                    product: product,
                    enableHistoryState: false, //template_index ? false : true,
                    onVariantSelected: function (variant, selector) {
                        timber[(variantStyle === "buttons" ? "productPage" : "productPageRegular")]($element, {
                            money_format: $element.attr('data-money-format'),
                            variant: variant,
                            selector: selector
                        });

                        clearInterval(window.buttonInterval);
                    }
                });

                if (variantStyle === "buttons") {
                    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
                    if (optionsSize == 1 && firstOption != 'Title') {
                        $('.radio-wrapper:eq(0)').prepend('<label for="ProductSelect-option-0" class="single-option-radio__label">' + firstOption + '</label>');
                    }
                    ;

                    // Hide drop-down selectors if we only have 1 variant and its title contains 'Default'.
                    if (variantsSize == 1 && firstVariantTitle.indexOf('Default') !== -1) {
                        $('.radio-wrapper').hide();
                    }
                    ;
                } else {
                    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
                    if (optionsSize == 1 && firstOption != 'Title') {
                        $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">' + firstOption + '</label>');
                    }
                    ;

                    // Hide selectors if we only have 1 variant and its title contains 'Default'.
                    if (variantsSize == 1 && firstVariantTitle.indexOf('Default') !== -1) {
                        $('.selector-wrapper').hide();
                    }
                    ;

                }
                myResolve();
            }
        });
    }
};

function initFitVids() {
    var $videoSection = $('.featured-video');
    if ($videoSection.length) {
        $videoSection.fitVids();
    }
}


// -----------------------------------------------------------
// Header cart

var headerCart = function ($el) {
    var moneyFormat = $el.data('header-cart'),
        $empty = $el.find('.header-cart-empty');

    var headerCartToggle = function (direction) {
        if (direction === 'show') {
            $el.addClass('animating');
            setTimeout(function () {
                $el.addClass('visible');
                headerCartItemHeight();
                $('[data-product-add-to-cart]').trigger('updateButton');
            }, 200);
        } else {
            $el.removeClass('visible');
            setTimeout(function () {
                $el.removeClass('animating');
            }, 200);
        }
    }

    var headerCartItemHeight = function () {
        var $headerCartItem = $el.find('[data-header-cart-item]');
        $headerCartItem.height('auto');

        $el.imagesLoaded(function () {
            $headerCartItem.each(function (i, el) {
                var $item = $(el);
                $item.height($item.height());
            });
        });
    }

    var headerCartUpdate = function (cart) {
        var total = Shopify.formatMoney(cart.total_price, moneyFormat);
        $el.find('[data-header-cart-total]').html(total);
        $('.cartItemCount').text(cart.item_count);

        if (cart.item_count === 0) {
            $('.cartItemCount').addClass('hidden')
            $('.header-cart-mobile').removeClass('has-items');
            setTimeout(function () {
                $empty.removeClass('hidden');
            }, 300);
        } else {
            $('.cartItemCount').removeClass('hidden')
            $('.header-cart-mobile').addClass('has-items');
            $empty.addClass('hidden');
        }
    }

    var headerCartBuildProduct = function (cart, alreadyInCart, cartItem, quantity) {
        if (alreadyInCart) {
            $el.find('[data-header-cart-item="' + cartItem.id + '"]').find('input').val(quantity);
            headerCartToggle('show');
        } else {

            Shopify.getProduct(cartItem.handle, function (product) {
                var options = product.options;
                var variant;

                for (var i in product.variants) {
                    if (product.variants[i].id === cartItem.id) {
                        variant = product.variants[i];
                    }
                }

                var variantOptions = '';
                if (cartItem.variant_options[0] !== 'Default Title') {
                    for (var i in cartItem.variant_options) {
                        variantOptions = variantOptions ? variantOptions + '<span>' + options[i].name + ' <strong>' + cartItem.variant_options[i] + '</strong></span>' : '<span>' + options[i].name + ' <strong>' + cartItem.variant_options[i] + '</strong></span>';
                    }
                }

                var image = Shopify.Image.getSizedImageUrl(cartItem.image, '160x'),
                    price = Shopify.formatMoney(cartItem.price, moneyFormat),
                    quantityLabel = Theme.localization.cart.quantity,
                    soldOutMessage = Theme.localization.cart.allInCart;

                var variantQuantity = variant.inventory_management === 'shopify' && variant.inventory_policy === 'deny'
                    ? variant.inventory_quantity
                    : 0;
                variantQuantity = variantQuantity === 0
                    ? ''
                    : 'max="' + variantQuantity + '"';

                $el.find('[data-header-cart-items]').append(
                    '<article class="header-cart-item" data-header-cart-item="' + cartItem.id + '">' +
                    '<a class="header-cart-item-image" href="' + cartItem.url + '">' +
                    '<img src="' + image + '">' +
                    '</a>' +
                    '<div class="header-cart-item-info">' +
                    '<h3><a href="' + cartItem.url + '">' + cartItem.product_title + '</a></h3>' +
                    '<span class="money">' + price + '</span>' +
                    '<div class="header-cart-item-options" data-header-cart-options>' +
                    variantOptions +
                    '<span>' +
                    quantityLabel + ' <strong><input type="number" min="0" ' + variantQuantity + ' value="' + cartItem.quantity + '" readonly></strong> ' +
                    '<button type="button" data-header-cart-quantity-increase="' + cartItem.id + '">&plus;</button> ' +
                    '<button type="button" data-header-cart-quantity-decrease="' + cartItem.id + '">&minus;</button> ' +
                    '</span>' +
                    '<span class="header-cart-sold-out" data-header-cart-sold-out>' + soldOutMessage + '</span>' +
                    '</div>' +
                    '</div>' +
                    '</article>'
                );

                headerCartToggle('show');
            });
        }
    }

    var headerCartAddItem = function (variantId) {
        var alreadyInCart = false;

        if ($el.find('[data-header-cart-item="' + variantId + '"]').length) {
            alreadyInCart = true;
        }
        Shopify.getCart(function (cart) {
            var quantity;
            var cartItem;
            $.each(cart.items, function (i, el) {
                if (el.id === parseInt(variantId, 10)) {
                    cartItem = el;
                    quantity = el.quantity;
                }
            });

            headerCartUpdate(cart);
            headerCartBuildProduct(cart, alreadyInCart, cartItem, quantity);
        });
    }

    var headerCartMaxReached = function ($cartItem) {
        var $target = $cartItem.find('[data-header-cart-sold-out]');

        $target.addClass('visible');

        setTimeout(function () {
            $target.removeClass('visible');
        }, 3000);
    }

    var headerCartEditQuantity = function (event, direction) {
        var $target = $(event.currentTarget),
            id = $target.data('header-cart-quantity-' + direction),
            $input = $target.closest('[data-header-cart-options]').find('input'),
            maxQuantity = $input.attr('max') ? parseInt($input.attr('max'), 10) : 1000000,
            quantity = parseInt($input.val(), 10);

        quantity = direction === 'increase' ? quantity + 1 : quantity - 1;

        if (quantity <= maxQuantity) {
            quantity = quantity;
        } else {
            quantity = quantity - 1;
            headerCartMaxReached($target.closest('[data-header-cart-item]'));
        }

        $input.val(quantity);

        if (quantity === 0) {
            var $item = $target.closest('[data-header-cart-item]');
            headerCartRemove($item, id, headerCartUpdate);
        } else {
            Shopify.changeItem(id, quantity, function (cart) {
                headerCartUpdate(cart);
            });
        }
    }

    var headerCartRemove = function ($item, id, callback) {
        Shopify.removeItem(id, function (cart) {
            $item.addClass('removed');

            setTimeout(function () {
                $item.remove();
            }, 200);

            callback(cart);
        });
    }

    var headerCartEvents = function () {
        $el.on('click', '[data-header-cart-quantity-increase]', function (event) {
            headerCartEditQuantity(event, 'increase');
        });

        $el.on('click', '[data-header-cart-quantity-decrease]', function (event) {
            headerCartEditQuantity(event, 'decrease');
        });

        $el.on('update', function (event, variantId) {
            headerCartAddItem(variantId);
        });

        $el.on('mouseleave', function () {
            headerCartToggle('hide');
        });

        $(window).on('resize', function () {
            headerCartItemHeight();
        });
    }

    headerCartItemHeight();
    headerCartEvents();

    headerCartInstance = $el;
}


// -----------------------------------------------------------
// Product add to cart

var productAdd = function ($el) {
    var adding = false;

    var productUpdateButton = function (reset, success) {
        var $button = $el.find('.add-to-cart'),
            $buttonText = $el.find('.add-to-cart-text'),
            text = $buttonText.text();

        if (reset) {
            $button
                .removeClass('active')
                .attr('disabled', 'disabled');
            if (success) {
                $buttonText.text(Theme.localization.product.addedToCart);
                window.buttonInterval = setInterval(function () {
                    $buttonText.text(text);
                    $button
                        .removeClass('disabled')
                        .removeAttr('disabled');
                    clearInterval(window.buttonInterval);
                }, 4000);
            } else {
                $button
                    .removeClass('disabled')
                    .removeAttr('disabled');
            }
        } else {
            $button
                .addClass('active disabled')
                .attr('disabled', 'disabled');
        }
    }

    var productAddError = function (errors) {
        var error = $.parseJSON(errors.responseText);

        if (error.message === 'Cart Error') {
            $el.find('.add-to-cart').append(
                '<span class="product-form-error">' + error.description + '</span>'
            );

            var $error = $el.find('.product-form-error');

            $error.addClass('animating');
            setTimeout(function () {
                $error.addClass('visible');
                productUpdateButton(true);
                adding = false;
                setTimeout(function () {
                    $error.removeClass('visible');
                    setTimeout(function () {
                        $error.remove();
                    }, 250);
                }, 3000);
            }, 200);
        }
    }

    var productAddItem = function () {
        if (!adding) {
            adding = true;
            productUpdateButton();
            jQuery.ajax({
                type: 'POST',
                url: window.root_url + '/cart/add.js',
                data: $el.find('form').serialize(),
                dataType: 'json',
                success: function (response) {
                    productUpdateButton(true);
                    headerCartInstance.trigger('update', response.variant_id);
                    adding = false;

                },
                error: function (XMLHttpRequest, textStatus) {
                    productAddError(XMLHttpRequest);
                }
            });
        }
    }

    var productAddEvents = function () {
        $el.on('click', '.add-to-cart', function (event) {
            event.preventDefault();
            productAddItem(event);
            return false;
        });

        $el.on('updateButton', function () {
            productUpdateButton(true, true);
        });
    }

    productAddEvents();
}

function initAccountActions() {
    $('.address-delete').click(function (e) {
        e.preventDefault();
        var $el = $(this),
            formId = $el.data('form-id'),
            confirmMessage = $el.data('confirm-message');
        if (confirm(confirmMessage || "Are you sure you wish to delete this address?")) {
            $.ajax({
                url: '/account/addresses/' + formId,
                type: 'DELETE',
                success: function (result) {
                    location.reload();
                },
                error: function (result) {
                    location.reload();
                }
            });
        }
    });

    $('.editAddress').click(function (e) {
        e.preventDefault();
        var $id = $(this).attr('href').replace('#', '');
        $('#EditAddress_addNew').hide();
        $('.editAddressForm').hide();
        $('#EditAddress_' + $id).show();
        $('#EditAddress_' + $id).find('.cancelEdit').click(function (e) {
            e.preventDefault();
            $('#EditAddress_' + $id).hide();
            $('#EditAddress_addNew').show();
        });
    });
}

